import {
    ICellMetric,
    ICellMetricAggregator,
    ICellMetricAggregatorCalcLevel,
    ICellMetricPushDownMethod,
    ICellMetricPushDownOptions,
    ICellMetricRenderOptions,
} from "./PA.HyperRectangle.IF";

import * as _ from "lodash";
import { EvalFunction, MathNode, parse, SymbolNode } from "mathjs";
import { ComputedAggr } from "./ComputedAggr";

export class ComputedMetric implements ICellMetric {
    private _metricId: string;
    private _metricName: string;
    private _metricFormula: string;
    private _metricFunction: EvalFunction;
    private _metricAggLevel: ICellMetricAggregatorCalcLevel;

    private _options: { [p: string]: any };
    private _groupName: string;
    private _renderOptions: ICellMetricRenderOptions;
    private _supportingMetricsIds: string[];
    private _bHidden: boolean;

    constructor(
        metricId: string,
        metricName: string,
        metricFormula: string,
        metricAggLevel: ICellMetricAggregatorCalcLevel,
        options?: { [p: string]: any },
        renderOptions?: ICellMetricRenderOptions,
        bHidden?: boolean,
        sGroupNameOvrd?: string,
    ) {
        //--
        this._metricId = metricId;
        this._metricName = metricName;
        this._metricFormula = metricFormula;
        this._metricAggLevel = metricAggLevel;
        this._options = options || {};
        this._renderOptions = renderOptions || <any>{};
        let groupNameOvrd = sGroupNameOvrd || this._renderOptions.groupName;
        this._groupName = groupNameOvrd || "Computed Metric";
        this._supportingMetricsIds = [];
        this._bHidden = false;

        if (_.isBoolean(bHidden)) this._bHidden = bHidden;
        let dctSymbols: { [id: string]: string } = {};
        let parsedFormula = parse(this._metricFormula);
        parsedFormula.traverse((node: MathNode & SymbolNode, path, parent) => {
            if (node.type == "SymbolNode") dctSymbols[node.name] = node.name;
        });
        this._supportingMetricsIds = _.values(dctSymbols);

        this._metricFunction = parsedFormula.compile();
    }

    get AggregatorCalcLevel(): ICellMetricAggregatorCalcLevel {
        return this._metricAggLevel;
    }
    Aggregator(): ICellMetricAggregator {
        return new ComputedAggr(this._metricFormula, this._metricFunction, this._supportingMetricsIds, 0);
    }

    get MetricId(): string {
        return this._metricId;
    }
    get MetricName(): string {
        return this._metricName;
    }
    get Options(): { [p: string]: any } {
        return this._options;
    }
    get GroupName(): string {
        return this._groupName;
    }
    get RenderOptions(): ICellMetricRenderOptions {
        return this._renderOptions;
    }
    get SupportingMetricsIds(): string[] {
        return this._supportingMetricsIds;
    }
    get bIsHidden(): boolean {
        return this._bHidden;
    }

    get PushDownMethod(): ICellMetricPushDownMethod {
        return undefined;
    }
    get PushDownOptions(): ICellMetricPushDownOptions {
        return {};
    }

    get bIsLeafLevelOnly(): boolean {
        return false;
    }
    get bIsReadOnly(): boolean {
        return true;
    }
}
